import { Outlet, useLocation, useSearchParams } from "react-router";
import { AuthLayout } from "@/components/auth/AuthLayout";
import { StepIndicator } from "@/components/ds";
import { SignupWizardProvider } from "@/components/auth/SignupWizardProvider";

const STEPS = ["Email", "Password", "Name"] as const;

const STEP_MAP: Record<string, number> = {
  "/signup": 0,
  "/signup/password": 1,
  "/signup/name": 2,
};

export function SignupLayout() {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const currentStep = STEP_MAP[pathname] ?? 0;
  const initialEmail = searchParams.get("email") ?? "";

  return (
    <SignupWizardProvider initialEmail={initialEmail}>
      <AuthLayout>
        <StepIndicator steps={STEPS} currentStep={currentStep} />
        <div style={{ marginTop: "var(--space-7)" }}>
          <Outlet />
        </div>
      </AuthLayout>
    </SignupWizardProvider>
  );
}
